import styled from "@emotion/styled";

const StyledContainer = styled.div({
  display: "grid",
  rowGap: "16px",
  textAlign: "center",
  alignContent: "center",
  justifyContent: "center",
  justifyItems: "center",
  minHeight: "70vh",
  margin: "0 auto",
});

const StyledColoredText = styled.span(({ color }) => ({
  color: `${color}`,
}));

const StyledButtonWrapper = styled.div({
  marginTop: "24px",
  width: "200px",
});

const StyledHeaderWrapper = styled.div({
  marginBottom: "16px",
});

const ButtonWrapper = ({ children }) => <StyledButtonWrapper>{children}</StyledButtonWrapper>;

const HeaderWrapper = ({ children }) => <StyledHeaderWrapper>{children}</StyledHeaderWrapper>;

const ColoredText = ({ children, color }) => <StyledColoredText color={color}>{children}</StyledColoredText>;

const Container = ({ children }) => <StyledContainer>{children}</StyledContainer>;

export { ButtonWrapper, ColoredText, Container, HeaderWrapper };
